export enum OrganisationRoles {
  SOLAR_CONSUMER = 'SOLAR CONSUMER',
  SOLAR_INSTALLER = 'SOLAR INSTALLER'
}
